import React from "react";
import { Star } from "lucide-react";

const HealthStats = () => {
  return (
    <section className="w-full py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4 text-center">

        {/* 🔹 Heading */}
        <h2 className="text-[22px] sm:text-[26px] md:text-[28px] font-semibold text-[#A4A5A8] mb-10">
          India's Largest Health Products Platform
        </h2>

        {/* 🔹 Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">

          {/* 1 */}
          <div>
            <h3 className="text-[28px] md:text-[35px] font-bold text-[#060A0B]">
              1.5L+
            </h3>
            <p className="text-[14px] md:text-[15px] text-[#A4A5A8]">
              Health Products
            </p>
          </div>

          {/* 2 */}
          <div>
            <h3 className="text-[28px] md:text-[35px] font-bold text-[#060A0B]">
              5L+
            </h3>
            <p className="text-[14px] md:text-[15px] text-[#A4A5A8]">
              Monthly Visitors
            </p>
          </div>

          {/* 3 */}
          <div>
            <h3 className="text-[28px] md:text-[35px] font-bold text-[#060A0B]">
              8L+
            </h3>
            <p className="text-[14px] md:text-[15px] text-[#A4A5A8]">
              Orders Delivered
            </p>
          </div>

          {/* 4 */}
          <div className="flex flex-col items-center">
            <div className="flex items-center gap-1">
              <h3 className="text-[28px] md:text-[35px] font-bold text-[#060A0B]">
                4.4
              </h3>
              <Star className="w-6 h-6 fill-[#060A0B] text-[#060A0B]" />
            </div>
            <p className="text-[14px] md:text-[15px] text-[#A4A5A8]">
              Google Rating
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HealthStats;
